export const WINDOW_VARIABLE_NAME = 'templateVariables'

export type AccountTemplateVariables = {
  customerToken: string
}

export type CashAppDownloadLink = {
  scheme?: string
  host?: string
  path?: string
  parameters?: Record<string, string>
}

export type ReferralProfile = {
  title?: string
  description?: string
  fullName?: string
  firstName?: string
  rewardAmount?: string
  personalQualifyingAmount?: string
  profilePhotoUrl?: string
  referralProgram?: 'CASH_APP_CARD' | 'P2P'
  deepLinkValue?: string
  cashAppDownloadLink?: CashAppDownloadLink
}

const templateVariables = typeof window !== 'undefined' ? (window[WINDOW_VARIABLE_NAME as keyof Window] ?? {}) : {}

export const accountTemplateVariables = templateVariables as Readonly<AccountTemplateVariables>
